// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import * as yup from "yup";
import { useMediaQuery, useTheme } from "@mui/material";
import useTranslation from "next-translate/useTranslation";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";

import { useStepperContext } from "@/hooks/useStepperContext";
import { Button, Form, Grid, Link, Typography } from "@/components/core";
import { useRegisterStoreStore } from "@/store/login/apply";

export function SignInEntrance() {
  const stepper = useStepperContext();
  const { t } = useTranslation("signup");
  const theme = useTheme();
  const mobileMediaQuery = theme.breakpoints.down("md");
  const isMobileDevice = useMediaQuery(mobileMediaQuery);

  const register = useRegisterStoreStore((state) => state.register);

  const formProps = {
    initialValues: {
      firmName: "",
      nameSurname: "",
      email: "",
      phone: "",
    },
    validationSchema: yup.object().shape({
      firmName: yup.string().required().nullable(),
      nameSurname: yup.string().required().nullable(),
      email: yup.string().email().required().nullable(),
      phone: yup.number().integer().required().nullable(),
    }),
    onSubmit: async (registerData) => {
      await register(registerData, stepper);
    },
  };

  return (
    <Form {...formProps}>
      <Grid sx={{ width: "320px", m: "auto", "& .MuiGrid-item": { paddingX: 0 } }}>
        <Grid.Item xs={12} sx={{ paddingY: 5 }}>
          <Grid spacing={1}>
            <Grid.Item xs>
              <Typography fontSize={26} bold textAlign={isMobileDevice ? "end" : "start"}>
                {t("signUp")}
              </Typography>
            </Grid.Item>
          </Grid>
        </Grid.Item>
        <Grid.Item xs={12}>
          <Typography sx={{ paddingBottom: 1, paddingTop: 2 }} fontSize={13}>
            {t("companyTitle")}
          </Typography>
          <Form.TextField variant="filled" name="firmName" required />
        </Grid.Item>
        <Grid.Item xs={12}>
          <Typography sx={{ paddingBottom: 1, paddingTop: 2 }} fontSize={13}>
            {t("companyAuthName")}
          </Typography>
          <Form.TextField variant="filled" name="nameSurname" fullWidth required />
        </Grid.Item>
        <Grid.Item xs={12}>
          <Typography sx={{ paddingBottom: 1, paddingTop: 2 }} fontSize={13}>
            {t("companyMail")}
          </Typography>
          <Form.TextField variant="filled" name="email" fullWidth required />
        </Grid.Item>
        <Grid.Item xs={12}>
          <Typography sx={{ paddingBottom: 1, paddingTop: 2 }} fontSize={13}>
            {t("companyTel")}
          </Typography>
          <Form.TextField variant="filled" name="phone" fullWidth required />
        </Grid.Item>
        <Grid.Item xs={12}>
          <Button
            sx={{
              fontSize: 15,
              paddingY: "10px",
              borderRadius: "8px",
              width: "100%",
              my: "15px",
            }}
            variant="contained"
            type="submit"
          >
            {t("Submit")}
          </Button>
        </Grid.Item>
      </Grid>
    </Form>
  );
}
